import { useContext } from "react";
import { Context } from "../../utils/context";

const SortButton = ({ value }) => {
  const { setSort, sort } = useContext(Context);
  const handleClick = (value) => {
    setSort((prev) => {
      if (prev[0] === value) {
        return [prev[0], !prev[1]];
      } else {
        return [value, true];
      }
    });
  };
  return (
    <>
      <button onClick={() => handleClick(value)}>
        <span
          className={sort[1] === true && sort[0] === value ? "current" : ""}
        ></span>
        <span
          className={sort[1] === false && sort[0] === value ? "current" : ""}
        ></span>
      </button>
    </>
  );
};
export default SortButton;
